export default __webpack_public_path__ + "static/media/edit.001f1520.svg";